<nav class="reports_navigation_menu">
    <ul *ngIf="reportStudiesData?.length">
        <ng-container *ngFor="let study of reportStudiesData[0].studies">
            <li  *ngIf="study.active" [class.active]="selectedStudies?.study_id === study.study_id">
                <a >{{study.study_label[currentLang]? study.study_label[currentLang]: study.study_label['1']}}</a>
                <ul *ngIf="study.reports?.length">
                    <ng-container *ngFor="let report of study.reports">
                        <li *ngIf="!report.hidden" [class.active]="selectedRepored?.report_id === report.report_id" (click)="selectReport(report, study, reportStudiesData[0])">
                            <a>
                                {{report.report_label[currentLang]? report.report_label[currentLang]: report.report_label['1']}} 
                                <span class="preonly-btn" *ngIf="!report.active">
                                    <mat-icon>visibility</mat-icon>
                                    {{ 'previewOnly' | translate }}
                                </span>
                            </a>

                            <div class="nav-report-info">
                                <mat-icon
                                    *ngIf="report.report_description"
                                    mat-icon-button>
                                    error_outline
                                </mat-icon>
                                    <div>
                                        <p
                                        (click)="$event.stopPropagation()"
                                        [innerHTML]="report.report_description | langtranslate">
                                        </p>
                                    </div>
                                </div>
                        </li>
                    </ng-container>
                </ul>
            </li>
        </ng-container>
    </ul>
</nav>
